import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './core/components/components.module';
import { AuthInterceptor } from './core/interceptors/auth';
import { ErrorHandlerInterceptor } from './core/interceptors/error-handler';
import { SharedModule } from './core/shared/shared.module';

import localePt from '@angular/common/locales/pt';
import { MAT_PAGINATOR_DEFAULT_OPTIONS, MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { BrowserFavicons, Favicons } from './core/favicons/favicons';
import { getPtPaginatorIntl } from './core/intl/paginator-intl';
import { PipesModule } from './core/pipes/pipes.module';
import { CoreEffects } from './core/store/effects';
import { metaReducers } from './core/store/meta-reducers';
import { coreReducer } from './core/store/reducers';
import { AuthModule } from './modules/auth/auth.module';
import { DadosCadastraisModule } from './modules/dados-cadastrais/dados-cadastrais.module';
import { ExtratoModule } from './modules/extrato/extrato.module';
import { HomeModule } from './modules/home/home.module';
import { PagamentosEDebitosModule } from './modules/pagamentos-e-debitos/pagamentos-e-debitos.module';
import { SegundaViaModule } from './modules/segunda-via/segunda-via.module';

registerLocaleData(localePt);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ComponentsModule,

    ToastrModule.forRoot(),

    AuthModule,
    DadosCadastraisModule,
    ExtratoModule,
    FontAwesomeModule,
    HomeModule,
    PagamentosEDebitosModule,
    SegundaViaModule,
    SharedModule,
    PipesModule,

    StoreModule.forRoot({ core: coreReducer }, { metaReducers }),

    !environment.production ? StoreDevtoolsModule.instrument() : [],

    EffectsModule.forRoot([CoreEffects]),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR',
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        position: 'right',
        disableTooltipInteractivity: true,
      },
    },
    {
      provide: MatPaginatorIntl,
      useValue: getPtPaginatorIntl(),
    },
    {
      provide: Favicons,
      useClass: BrowserFavicons,
    },
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: {
        formFieldAppearance: 'outline',
        showFirstLastButtons: true,
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
